import { hideModal } from 'actions/modal';
import DatePicker from 'components/shared/form/presentational/DatePicker';
import Field from 'components/shared/form/presentational/Field';
import Form from 'components/shared/form/presentational/Form';
import Select from 'components/shared/form/presentational/Select';
import SectionTitle from 'components/shared/generic/sectionTitle/presentational/SectionTitle';
import { StatementType } from 'constants/shared/enums';
import dayjs from 'dayjs';
import React from 'react';
import { useDispatch } from 'react-redux';
import useTranslate from 'suits-me-npm/languages/useTranslate';
import { api, useForm } from 'suits-me-npm/utils';
import { downloadFile } from 'utils/generic';
import ModalOuterContainer from '../generic/containers/ModalOuterContainer';

const statementTypeOptions = Object.entries(
    StatementType,
).map(([key, value]) => ({ value, label: key }));

const ExportStatementModal = () => {
    const dispatch = useDispatch();
    const [{ statementType, dateFrom, dateTo }, handleChange] = useForm({
        statementType: StatementType.PDF,
        dateFrom: dayjs()
            .subtract(1, 'month')
            .toDate(),
        dateTo: dayjs().toDate(),
    });

    const downloadStatement = () => {
        const start = dayjs(dateFrom).format('YYYY-MM-DD');
        const end = dayjs(dateTo).format('YYYY-MM-DD');
        let fileName = `Statement-${start}-${end}`;
        if (statementType === StatementType.PDF) fileName += '.pdf';
        if (statementType === StatementType.CSV) fileName += '.csv';

        api.download(
            `statement?dateFrom=${start}&dateTo=${end}&format=${statementType}`,
        ).then(res => {
            downloadFile(res.data, fileName);
            dispatch(hideModal());
        });
    };

    const translate = useTranslate('exportStatementModal');

    return (
        <ModalOuterContainer customButtons>
            <Form
                onSubmit={downloadStatement}
                onCancel={() => dispatch(hideModal())}
                submitText={translate('submit')}
                cancelText={translate('cancel')}
            >
                <SectionTitle title={translate('titleText')} />
                <Field name={translate('statementType')} required>
                    <Select
                        classes="generic-input modal-select"
                        omitPlaceholder
                        required
                        name="statementType"
                        onChange={handleChange}
                        value={statementType}
                        options={statementTypeOptions}
                    />
                </Field>
                <Field name={translate('dateFrom')}>
                    <DatePicker
                        classes="generic-input"
                        value={dateFrom}
                        onChange={handleChange}
                        name="dateFrom"
                        maxDate={new Date()}
                    />
                </Field>
                <Field name={translate('dateTo')}>
                    <DatePicker
                        classes="generic-input"
                        value={dateTo}
                        onChange={handleChange}
                        name="dateTo"
                        maxDate={new Date()}
                    />
                </Field>
            </Form>
        </ModalOuterContainer>
    );
};

export default ExportStatementModal;
